/**
 * Abre una URL en pestaña nueva sin window.open (evita ERR_BLOCKED_BY_RESPONSE
 * en sitios como WeTransfer cuando la app va dentro de iframes del CRM).
 */
export function openExternalUrl(url) {
  const href = String(url || "").trim();
  if (!href) return false;

  try {
    const anchor = document.createElement("a");
    anchor.href = href;
    anchor.target = "_blank";
    anchor.rel = "noopener noreferrer";
    anchor.referrerPolicy = "no-referrer";
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    return true;
  } catch {
    return false;
  }
}

/** true si el documento está dentro de un iframe (p. ej. cuerpo del email en Matrix). */
export function isInsideIframe() {
  try {
    return window.parent !== window;
  } catch {
    return true;
  }
}

/** true si hay más de un nivel de iframe (cuerpo del email dentro de Matrix). */
export function shouldDelegateLinksToHost() {
  let depth = 0;
  let w = window;
  try {
    while (w.parent && w.parent !== w) {
      depth += 1;
      w = w.parent;
    }
  } catch {
    return true;
  }
  return depth > 1;
}

export function isEmbeddedInHost() {
  try {
    if (new URLSearchParams(window.location.search).get("embedded") === "1") {
      return true;
    }
  } catch {
    /* ignore */
  }
  return shouldDelegateLinksToHost();
}

export function requestOpenExternalLink(url) {
  const href = String(url || "").trim();
  if (!href) return;

  if (isEmbeddedInHost()) {
    try {
      window.parent.postMessage({ type: "UNIBOX_OPEN_LINK", url: href }, "*");
    } catch {
      openExternalUrl(href);
    }
    return;
  }

  openExternalUrl(href);
}
